import React from "react";
import "./PartnerCarousel.css";

const logos = [
  {
    id: "sbi",
    src: "/images/Bank Logos/sbibank.png",
    alt: "State Bank of India",
    link: "https://homeloans.sbi/",
  },
  {
    id: "iob",
    src: "/images/Bank Logos/indiaoverseasbank.png",
    alt: "Indian Overseas Bank",
    link: "https://www.iob.in/home-loans.aspx",
  },
  {
    id: "icici",
    src: "/images/Bank Logos/icicibank.png",
    alt: "ICICI Bank",
    link: "https://shorturl.at/hnkdg",
  },
  {
    id: "hdfc",
    src: "/images/Bank Logos/hdfcbank.png",
    alt: "HDFC Bank",
    link: "https://www.hdfc.com/housing-loans/home-loans",
  },
  {
    id: "boi",
    src: "/images/Bank Logos/bankofindia.png",
    alt: "Bank of India",
    link: "https://bankofindia.co.in/home-loan",
  },
  {
    id: "idbi",
    src: "/images/Bank Logos/idbibank.png",
    alt: "IDBI Bank",
    link: "https://www.idbibank.in/home-loan.aspx",
  },
  {
    id: "bob",
    src: "/images/Bank Logos/bankofbarodha.png",
    alt: "Bank of Baroda",
    link:
      "https://www.bankofbaroda.in/personal-banking/loans/home-loan",
  },
  {
    id: "cbi",
    src: "/images/Bank Logos/centralbankofindia.png",
    alt: "Central Bank of India",
    link:
      "https://www.centralbankofindia.co.in/en/housing-loan",
  },
  {
    id: "bom",
    src: "/images/Bank Logos/bankofmaharashtra.png",
    alt: "Bank of Maharashtra",
    link:
      "https://bankofmaharashtra.in/personal-banking/loans/home-loan",
  },
  {
    id: "bandhan",
    src: "/images/Bank Logos/bandhan_bank.png",
    alt: "Bandhan Bank",
    link: "https://bandhanbank.com/personal/home-loan",
  },
  {
    id: "standard-chartered",
    src: "/images/Bank Logos/standard_chartered_bank.png",
    alt: "Standard Chartered Bank",
    link:
      "https://www.sc.com/in/loans/home-property-loans/home-loans/",
  },
  {
    id: "kotak",
    src: "/images/Bank Logos/kotak_mahindra_bank.png",
    alt: "Kotak Mahindra Bank",
    link:
      "https://www.kotak.com/en/personal-banking/loans/home-loan.html",
  },
  {
    id: "indusind",
    src: "/images/Bank Logos/indusind_bank.png",
    alt: "IndusInd Bank",
    link:
      "https://www.indusind.com/in/en/personal/loans/home-loan.html",
  },
];

const Partner = () => {
  const repeatedLogos = [...logos, ...logos];

  return (
    <section
      className="partner-section"
      aria-labelledby="partner-section-title"
    >
      <div
        className="partner-background-glow partner-glow-left"
        aria-hidden="true"
      ></div>

      <div
        className="partner-background-glow partner-glow-right"
        aria-hidden="true"
      ></div>

      <div className="partner-section-container">
        <div className="partner-section-header">
          <span className="partner-section-eyebrow">
            Banking Network
          </span>

          <h2 id="partner-section-title">
            Our trusted
            <span> lending partners</span>
          </h2>

          <p>
            Monayra works with leading public and private sector banks to help
            customers explore suitable loan options.
          </p>
        </div>

        <div className="partner-carousel-wrapper">
          <div
            className="partner-carousel-fade partner-carousel-fade-left"
            aria-hidden="true"
          ></div>

          <div
            className="partner-carousel-fade partner-carousel-fade-right"
            aria-hidden="true"
          ></div>

          <div className="partner-carousel-track">
            {repeatedLogos.map((logo, index) => (
              <a
                href={logo.link}
                target="_blank"
                rel="noopener noreferrer"
                className="partner-logo-card"
                key={`${logo.id}-${index}`}
                aria-label={`Visit ${logo.alt} website`}
                aria-hidden={index >= logos.length}
                tabIndex={index >= logos.length ? -1 : 0}
              >
                <div className="partner-logo-image-wrapper">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="partner-logo-image"
                    loading="lazy"
                  />
                </div>
              </a>
            ))}
          </div>
        </div>

        <div className="partner-section-features">
          <div className="partner-feature-item">
            <span className="partner-feature-icon">
              <i className="bi bi-bank"></i>
            </span>

            <div>
              <strong>Multiple Banks</strong>
              <small>Public and private sector lenders</small>
            </div>
          </div>

          <div className="partner-feature-item">
            <span className="partner-feature-icon">
              <i className="bi bi-bar-chart"></i>
            </span>

            <div>
              <strong>Loan Comparison</strong>
              <small>Explore suitable lending options</small>
            </div>
          </div>

          <div className="partner-feature-item">
            <span className="partner-feature-icon">
              <i className="bi bi-headset"></i>
            </span>

            <div>
              <strong>Expert Assistance</strong>
              <small>Support throughout your loan journey</small>
            </div>
          </div>
        </div>

        <div className="partner-section-disclaimer">
          <i className="bi bi-info-circle"></i>

          <p>
            Bank logos and trademarks belong to their respective owners.
            Approval, interest rates and loan terms depend on lender policies
            and applicant eligibility.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Partner;